import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import LegalHome from "@/pages/LegalHome";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import PrivacyChoices from "@/pages/PrivacyChoices";
import DeleteAccount from "@/pages/DeleteAccount";
import Support from "@/pages/Support";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App pb-grain">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Nav />
          <main>
            <Routes>
              <Route path="/" element={<LegalHome />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/privacy-choices" element={<PrivacyChoices />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
              <Route path="/support" element={<Support />} />
            </Routes>
          </main>
          <Footer />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            borderRadius: 0,
            border: "1px solid #E0E0D9",
            background: "#F9F9F6",
            color: "#0A0A0A",
            fontFamily: "Satoshi, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
